module.exports = __webpack_public_path__ + "static/media/1879.25e51cb2.jpg";